const experimentUniverses = { };

const experimentSettings = { };

const experimentTriggers = {
    SITE_ENTRY: "SiteEntry",
    PAGE_ENTRY: "PageEntry",
};

export { experimentUniverses, experimentSettings, experimentTriggers };
